import React, { useCallback, useEffect, useRef, useState } from "react";
import { IoClose } from "react-icons/io5";
import { Select, Tag } from "antd";
import "antd/dist/reset.css";
import { toast } from "react-hot-toast";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { customStyles } from "../../selectStyles";
import SelectPrivacy from "react-select";
import EditSharpIcon from "@mui/icons-material/EditSharp";

import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import parse from "html-react-parser";
import Delta from "quill-delta";
import Quill from 'quill';
import "quill/dist/quill.snow.css";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
// import Cropper from "react-easy-crop";
import { reset } from "linkifyjs";
import { useTranslation } from "react-i18next";


// Utility function for creating image from URL
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", (error) => reject(error));
    image.setAttribute("crossOrigin", "anonymous");
    image.src = url;
  });

// Convert degrees to radians
function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

// Function to get cropped image
async function getCroppedImg(imageSrc, pixelCrop, rotation = 0) {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  const maxSize = Math.max(image.width, image.height);
  const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

  // Set canvas dimensions
  canvas.width = safeArea;
  canvas.height = safeArea;

  // Translate canvas context for rotation
  ctx.translate(safeArea / 2, safeArea / 2);
  ctx.rotate(getRadianAngle(rotation));
  ctx.translate(-safeArea / 2, -safeArea / 2);

  // Draw rotated image
  ctx.drawImage(
    image,
    safeArea / 2 - image.width * 0.5,
    safeArea / 2 - image.height * 0.5
  );
  const data = ctx.getImageData(0, 0, safeArea, safeArea);

  // Set canvas to final crop size
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  // Place image data at correct position
  ctx.putImageData(
    data,
    Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
    Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
  );

  // Return as a blob URL
  return new Promise((resolve) => {
    canvas.toBlob((file) => {
      resolve(URL.createObjectURL(file));
    }, "image/jpeg");
  });
}


const AddArticle = ({ showModal, closeModal, setPostList, restrictedViewerToken }) => {
  const [title, setTitle] = useState("");
  const [tags, setTags] = useState([]);
  const language = localStorage.getItem("Lang");

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      document.body.classList.add("modal-open");
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "";
      document.body.classList.remove("modal-open");
    }
  }, [showModal]);

  // const tagOptions = ["React", "Mongo", "Express", "Node"];

  // Selected tags state
  // const [selectedTags, setSelectedTags] = useState([]);

  // Handle tag change
  // const handleTagChange = (values) => {
  //   setSelectedTags(values);
  // };

  //Tags
  const { t } = useTranslation();

  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get("/Posts/GetArticleTagsList");
         setTagOptions(response?.data?.responseData);
          
      } catch (error) {
        console.error("Failed to fetch tag options:", error);
      }
    };

    fetchTags();
  }, []);

  const handleTagChange = (values) => {
    setSelectedTags(values);
  };

  //Tag Closed

  //Rich Text Editor
  const editorRef = useRef(null);

  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    ["link", "image"],
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ];

  const modules = {
    toolbar: toolbarOptions,
    clipboard: {
      matchVisual: true,
    },
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "script",
    "link",
    "image",
    "code-block",
    "color",
    "background",
    "align",
    "direction",
  ];

  //Rich text editor closed

  //Add article
  const sessionId = localStorage.getItem("sessionId");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [display, setDisplay] = useState(false);
  const [isloading, setIsloading] = useState(false);

  const [images, setImages] = useState([]);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);
  const userUid = localStorage.getItem("userUid");
  const [description, setDescription] = useState("");
  const [SearchText, setSearchText] = useState("")

  const handleArticleChange = (content, delta, source, editor) => {
    const value = editor.getText(); // plain text, better than content HTML
    const caret = editor.getSelection()?.index || 0;

    setDescription(content); // still keep full HTML
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues?.filter(
      ({ type, display }) => {
        const prefix = type === "UserMention" ? "@" : "#";
        const fullMention = `${prefix}${display}`;
        return value.includes(fullMention);
      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText);
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    const updatedPostDynamicValues = [
      ...safePostDynamicValues,
      {
        type: mentionType,
        dVno,
        entity: mentionType === "UserMention" ? userUid : suggestion,
        display: displayName,
      },
    ];
    setPostDynamicValues(updatedPostDynamicValues);

    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  // Validate title - only allow alphanumeric characters and spaces, no double spaces
  const handleTitleChange = (e) => {
    const value = e.target.value;
    // Allow only letters, numbers, and spaces
    let validatedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    // Remove multiple consecutive spaces and replace with single space
    validatedValue = validatedValue.replace(/\s+/g, " ");
    setTitle(validatedValue);
  };

  const [privacyType, setPrivacyType] = useState(t("Public"));
  const Privacy = [
    // { value: "Public", label: "Public" },
    // { value: "Friends", label:"Friends"  },
    // { value: "OnlyMe", label: "OnlyMe" },
    // { value: "Custom", label: "Custom" },
    { value: "Public", label: t("Newsfeed.Public") },
    { value: "Friends", label: t("Newsfeed.Friends") },
    { value: "OnlyMe", label: t("Newsfeed.OnlyMe") },
    { value: "Custom", label: t("Newsfeed.Custom") },
  ];

  // const handleSubmit = async () => {

  //   setIsloading(true);
  //   try {

  //     setDisplay(true);
  //     const formData = new FormData();
  //     formData.append("DeviceType", "Web");
  //     formData.append("sessionId", sessionId);
  //     formData.append("PrivacyType", privacyType || "Public");
  //     formData.append("PostOriginType", "User");
  //     formData.append("BannerFile", bannerImage);
  //     formData.append("PostOriginID", userUid);
  //     formData.append("PostCategory", "Article");
  //     formData.append("Title", title);
  //     formData.append(
  //       "PostContent",
  //       postInputValue ? postInputValue : description
  //     );
  //     formData.append("Tags", selectedTags);
  //     formData.append("DynamicValues", JSON.stringify(postDynamicValues));
  //     const res = await axios.post("/Posts/CreateArticle", formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });
  //     setShowToast(true);
  //     setToastMessage(res?.data?.message || "Article created successfully");
  //     const newPostId = res?.data?.responseData?.id;
  //     const postDetailsResponse = await axios.get(
  //       `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}`
  //     );
  //     const newPost = postDetailsResponse?.data?.responseData.postInfo;
  //     console.log("newPostnewPost", newPost);

  //     setPostList((prev) => [newPost, ...prev]);

  //     setTitle("");
  //     setBannerImage(null);
  //     setDescription("");
  //     setSelectedTags([]);
  //     setPostInputValue("");
  //     setPostDynamicValues([]);
  //     closeModal();

  //     setIsloading(false);
  //     setPostDynamicValues([]);
  //     setPostInputValue("");
  //   } catch (error) {
  //     console.log("newPostId", error);
  //     if (error.response || error.response.status === 404 || error.response.status === 400) {
  //       setWarningToastMessage(error.response.data.title);
  //       setShowWarningToast(true);
  //     } else {
  //       setErrorToastMessage(error.response.data.title);
  //       setShowErrorToast(true);
  //     }
  //     setIsloading(false);
  //   }

  // };

  //Image crop

  const reset = () => {
    setDisplay(false);

    setTitle("");
    setBannerImage(null);
    setDescription("");
    setSelectedTags([]);
    setPostInputValue("");
    setPostDynamicValues([]);

  }

  const handleSubmit = async (e) => {
    setDisplay(true);

    if (e) e.preventDefault();

    if (!bannerImage) {
      setWarningToastMessage(t("Newsfeed.Please upload a banner image"));
      setShowWarningToast(true);
      return;
    }

    if (
      // !bannerImage &&
      title.trim() === "" &&
      selectedTags === "" &&
      postInputValue.trim() === "" ||
      description.trim() === ''
    ) {
      setWarningToastMessage(t("modals.Please fill all the required fields"));
      setShowWarningToast(true);
      return; // stop execution if validation fails
    }

    setIsloading(true);
    try {

      const formData = new FormData();
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append("PrivacyType", privacyType || "Public");
      formData.append("PostOriginType", "User");
      formData.append("BannerFile", bannerImage);
      formData.append("PostOriginID", userUid);
      formData.append("PostCategory", "Article");
      formData.append("Title", title);
      formData.append("PostContent", postInputValue || description);
      // formData.append("Tags", selectedTags);  
      formData.append("Tags", JSON.stringify(selectedTags));
      formData.append("langKey", language === "en" ? "" : language,);



      formData.append("DynamicValues", JSON.stringify(postDynamicValues));

      const res = await axios.post("/Posts/CreateArticle", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setShowToast(true);
      setToastMessage(res?.data?.message || "Article created successfully");

      const newPostId = res?.data?.responseData?.id;
      const postDetailsResponse = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
      );

      const newPost = postDetailsResponse?.data?.responseData?.postInfo;
      console.log("newPostnewPost", newPost);

      setPostList((prev) => [newPost, ...prev]);

      // ✅ Reset fields after success
      reset();
      // setDisplay(false);

      // setTitle("");
      // setBannerImage(null);
      // setDescription("");
      // setSelectedTags([]);
      // setPostInputValue("");
      // setPostDynamicValues([]);

      closeModal();
      setIsloading(false);
    } catch (error) {
      console.log("newPostId", error);

      if (error.response && (error.response.status === 404 || error.response.status === 400)) {
        setWarningToastMessage(error.response.data.message || error.response.data.title);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error?.response?.data?.message);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };


  const [bannerImage, setBannerImage] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [cropper, setCropper] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [rotation, setRotation] = useState(0);

  const [extraImages, setExtraImages] = useState([]);
  const [activeCropIndex, setActiveCropIndex] = useState(null); // which extra image to crop
  const [extraCroppedAreaPixels, setExtraCroppedAreaPixels] = useState(null);



  // Handle file selection
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageUrl = URL.createObjectURL(file);
      setImagePreview(imageUrl);
      // setShowCropper(true);
      setBannerImage(file); // keep original file
      setShowCropper(true); // cropper won’t open yet
    }
  };

  const handleAddNewImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const imageUrl = URL.createObjectURL(file);

      // Add to array
      setExtraImages((prev) => [...prev, { file, url: imageUrl }]);
    }
  };


  // When crop is completed
  // const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
  //   setCroppedAreaPixels(croppedAreaPixels);
  // }, []);
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    if (activeCropIndex !== null) {
      setExtraCroppedAreaPixels(croppedAreaPixels);
    } else {
      setCroppedAreaPixels(croppedAreaPixels); // old main image logic
    }
  }, [activeCropIndex]);


  // Apply crop and save image
  // const saveCroppedImage = async () => {
  //   try {
  //     const croppedImageUrl = await getCroppedImg(
  //       imagePreview,
  //       croppedAreaPixels,
  //       rotation
  //     );

  //     // Convert blob URL to File object
  //     const response = await fetch(croppedImageUrl);
  //     const blob = await response.blob();
  //     const file = new File([blob], "cropped-image.jpg", {
  //       type: "image/jpeg",
  //     });

  //     setBannerImage(file);
  //     setImagePreview(croppedImageUrl); // show cropped version
  //     setShowCropper(false);
  //   } catch (e) {
  //     console.error("Error cropping image:", e);
  //   }
  // };

// Apply crop and save image
const saveCroppedImage = async () => {
  try {
    if (!cropper) return;

    const canvas = cropper.getCroppedCanvas({
      width: 1920,
      height: 1080,
    });

    const croppedImageUrl = canvas.toDataURL("image/jpeg");

    // convert base64 to blob
    const response = await fetch(croppedImageUrl);
    const blob = await response.blob();

    const file = new File([blob], "cropped-image.jpg", {
      type: "image/jpeg",
    });

    setBannerImage(file);
    setImagePreview(croppedImageUrl);
    setShowCropper(false);

  } catch (e) {
    console.error("Error cropping image:", e);
  }
};

  const saveCroppedExtraImage = async () => {
    try {
      const croppedImageUrl = await getCroppedImg(
        extraImages[activeCropIndex].url,
        extraCroppedAreaPixels,
        rotation
      );

      // Convert blob URL to File
      const response = await fetch(croppedImageUrl);
      const blob = await response.blob();
      const file = new File([blob], `extra-cropped-${activeCropIndex}.jpg`, {
        type: "image/jpeg",
      });

      // Replace that extra image
      const updatedImages = [...extraImages];
      updatedImages[activeCropIndex] = { file, url: croppedImageUrl };
      setExtraImages(updatedImages);

      // close cropper
      setActiveCropIndex(null);
    } catch (e) {
      console.error("Error cropping extra image:", e);
    }
  };

  // Cancel cropping
  const cancelCropping = () => {
    setShowCropper(false);
    setImagePreview(null);
  };
  // const handleFileChange = (e) => {
  //   if (e.target.files && e.target.files[0]) {
  //     setBannerImage(e.target.files[0]);
  //   }
  // };


  const quillRef = useRef(null);
  const quillInstance = useRef(null);

 useEffect(() => {
  if (quillRef.current && !quillInstance.current) {
    quillInstance.current = new Quill(quillRef.current, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ size: ["small", false, "large", "huge"] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link", "image"],
          ["clean"],
        ],
      },
      formats: [
        "size",
        "bold",
        "italic",
        "underline",
        "strike",
        "list",
        "bullet",
        "link",
        "image",
      ],
      placeholder: t("Newsfeed.Write or paste your article content here..."),
    });

    // ✅ Set initial content
    if (description) {
      quillInstance.current.root.innerHTML = description;
    }

    // ✅ Handle content change
    quillInstance.current.on("text-change", (delta, oldDelta, source) => {
      const html = quillInstance.current.root.innerHTML;
      handleArticleChange(html, delta, source, quillInstance.current);
    });
  }
}, []);


  //Image crop closed
  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block" }}
        >
          <div className="container articleContainer mt-4 mb-5  d-flex justify-content-center">
            <div className="col-12">
              <form className="pb-4 HuzaifaAddArticleForm" onSubmit={handleSubmit}>
                <div className="row mb-md-4 mb-2 mt-2">
                  <div className=" modalBorder d-flex justify-content-between align-items-center p-2">
                    <div className="gap-3 d-flex justify-content-between align-items-center p-2">
                      <h6>{t("Newsfeed.Create an Article")}</h6>
                      <SelectPrivacy
                        defaultValue={Privacy.find(
                          (option) => option.value === privacyType
                        )}
                        onChange={(selectedOption) => {
                          setPrivacyType(selectedOption.value);
                        }}
                        options={Privacy}
                        placeholder={t("Newsfeed.Select Privacy")}
                        styles={customStyles}
                        formatOptionLabel={({ label, icon }) => (
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {icon}
                            <span style={{ marginLeft: 8 }}>{label}</span>
                          </div>
                        )}
                      />
                    </div>
                    <CloseSharpIcon className="pointer" onClick={closeModal} />
                  </div>
                </div>

                <div className="row g-4">
                  <div className="col-12 mb-4">
                    <label className="form-label fw-medium">
                      {t("Newsfeed.Banner Image")}
                      <span className="text-danger ms-2">*</span>
                    </label>
                    <div className="w-full max-w-4xl mx-auto">
                      {/* Article form fields would go here */}
                      <div className="mb-6">
                        {/* 2️⃣ If we have preview (but not cropping) */}

                        <div className="Inside-image-container">
                          {imagePreview && !showCropper && (
                            <div className="preview-container text-center position-relative d-inline-block">
                              {/* ✅ Close (X) button in corner */}
                              <button
                                type="button"
                                onClick={() => {
                                  setImagePreview(null);
                                  setBannerImage(null);
                                }}
                                style={{
                                  position: "absolute",
                                  top: "8px",
                                  right: "8px",
                                  backgroundColor: "rgba(0,0,0,0.6)",
                                  border: "none",
                                  color: "white",
                                  fontSize: "20px",
                                  fontWeight: "bold",
                                  borderRadius: "50%",
                                  width: "32px",
                                  height: "32px",
                                  lineHeight: "28px",
                                  cursor: "pointer",
                                }}
                              >
                                ×
                              </button>


                              {/* Preview Image */}
                              <img
                                src={imagePreview}
                                alt="Preview"
                                className="img-fluid mb-3 rounded"
                                style={{ maxHeight: "300px" }}
                              />

                              {/* Crop button below */}
                              <div className="old-button-area d-flex justify-content-center gap-2">
                                {/* <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => setShowCropper(true)}
                                > */}
                                  {/* {t("Newsfeed.Crop")} */}
                                  <span
                                    className="  pointer"
                                    style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                                    onClick={() => setShowCropper(true)}
                                     
                                    >

                                    <EditSharpIcon   className="material-symbols-sharp" />
                                    </span>
                                
                                {/* </button> */}

                                {/* Add Image button */}
                                {/* <button
                                  type="button"
                                  className="btn btn-sm btn-outline-success"
                                  onClick={() => document.getElementById("addNewImage").click()}
                                >
                                  {t("Newsfeed.Add Image")}
                                </button> */}
                                <input
                                  id="addNewImage"
                                  type="file"
                                  className="d-none"
                                  accept="image/*"
                                  onChange={handleAddNewImage}
                                />
                              </div>
                            </div>
                          )}

                          {/* New Image add karna ke liya function h yeh */}
                          {extraImages.length > 0 && activeCropIndex !== 0 && (
                            <div className="Extranew-Image-area">
                              {extraImages.map((img, index) => (
                                <div
                                  key={index}
                                  className="preview-container text-center position-relative d-inline-block Extranew-personal-img"
                                >
                                  {/* Close button */}
                                  <button
                                    type="button"
                                    onClick={() =>
                                      setExtraImages(extraImages.filter((_, i) => i !== index))
                                    }
                                    style={{
                                      position: "absolute",
                                      top: "8px",
                                      right: "8px",
                                      backgroundColor: "rgba(0,0,0,0.6)",
                                      border: "none",
                                      color: "white",
                                      fontSize: "20px",
                                      fontWeight: "bold",
                                      borderRadius: "50%",
                                      width: "32px",
                                      height: "32px",
                                      lineHeight: "28px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    ×
                                  </button>

                                  {/* Preview Image */}
                                  <img
                                    src={img.url}
                                    alt={`Extra ${index}`}
                                    className="img-fluid mb-3 rounded"
                                    style={{ maxHeight: "300px" }}
                                  />

                                  {/* ✅ Crop button for this image */}
                                  <div className="new-button-area ">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-primary"
                                      onClick={() => setActiveCropIndex(index)}
                                    >
                                      {t("Newsfeed.Crop")}
                                    </button>

                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-success"
                                      onClick={() => document.getElementById("addNewImage").click()}
                                    >
                                      {t("Newsfeed.Add Image")}
                                    </button>
                                    <input
                                      id="addNewImage"
                                      type="file"
                                      className="d-none"
                                      accept="image/*"
                                      onChange={handleAddNewImage}
                                    />
                                  </div>

                                  {/* Add Image button */}

                                </div>
                              ))}
                            </div>
                          )}
                        </div>


                        {/* If we are in cropper mode   Old and New both  START*/}
                        {showCropper && (
                          <div className="bg-white rounded shadow-sm p-3">
                            <h6 className="mb-3"> {t("Newsfeed.Crop Your Image")}</h6>
                            <div
                              style={{
                                position: "relative",
                                height: "240px",
                                background: "#f0f0f0",
                              }}
                              className="mb-3"
                            >
                              {/* <Cropper
                                image={imagePreview}
                                crop={crop}
                                zoom={zoom}
                                aspect={16 / 9}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                rotation={rotation}
                              /> */}
                              <Cropper
                                  src={imagePreview}
                                  style={{ height: 240, width: "100%" }}
                                  // initialAspectRatio={16 / 9}
                                  aspectRatio={16 / 9} 
                                  guides={true}
                                  viewMode={1}
                                  dragMode="move"
                                  cropBoxResizable={true}
                                  cropBoxMovable={true}
                                  background={false}
                                  responsive={true}
                                  autoCropArea={1}
                                  checkOrientation={false}
                                  onInitialized={(instance) => {
                                    setCropper(instance);
                                  }}
                                />
                            </div>

                            <div className="d-flex justify-content-end gap-2">
                              <button
                                type="button"
                                className="closebtn"
                                onClick={() => setShowCropper(false)}
                              >
                                {t("Connections.Cancel")}
                              </button>
                              <button
                                type="button"
                                className="mainBtn1"
                                onClick={saveCroppedImage}
                              >
                                {t("Newsfeed.Apply Crop")}
                              </button>
                            </div>
                          </div>
                        )}


                        {activeCropIndex !== null && (
                          <div className="bg-white rounded shadow-sm p-3">
                            <h6 className="mb-3">{t("Newsfeed.Crop Extra Image")} </h6>
                            <div
                              style={{
                                position: "relative",
                                height: "240px",
                                background: "#f0f0f0",
                              }}
                              className="mb-3"
                            >
                              <Cropper
                                image={extraImages[activeCropIndex].url}
                                crop={crop}
                                zoom={zoom}
                                aspect={16 / 9}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                                rotation={rotation}
                              />
                            </div>

                            <div className="d-flex justify-content-end gap-2">
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => setActiveCropIndex(null)}
                              >
                                {t("Connections.Cancel")}
                              </button>
                              <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={saveCroppedExtraImage}
                              >
                                {t("Newsfeed.Apply Crop")}
                              </button>
                            </div>
                          </div>
                        )}
                        {/* If we are in cropper mode   Old and New both  END*/}



                        {/* 3️⃣ If no image uploaded */}
                        {!imagePreview && !showCropper && extraImages.length === 0 && (
                          <div className="card rounded-0">
                            <div className="card-body Article-body">
                              <div className="custom-file-upload text-center p-2">
                                {/* <div className="upload-icon mb-3"> ...your svg... </div> */}
                                <p className="mb-3">
                                  {t("Newsfeed.We recommend uploading or dragging in an image that is 1920x1080 pixels")}

                                </p>
                                <button
                                  className="mainBtn"
                                  type="button"
                                  onClick={() => document.getElementById("fileUpload").click()}
                                >
                                  {t("Newsfeed.Upload from file")}
                                </button>
                                <input
                                  id="fileUpload"
                                  type="file"
                                  className="d-none"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                        {display && (!bannerImage || bannerImage === "") && (
                          <span className="error_msg_lbl"> {t("Newsfeed.Please upload a banner image")} </span>
                        )}

                      </div>
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label fw-medium">{t("Newsfeed.Title")}<span className="text-danger ms-1 f-12">* (Special characters not allowed)</span>
                    </label>
                    <div className="input-wrapper">
                      <input
                        type="text"
                        className="form-control rounded-0 HuzTitleInput"
                        placeholder={t("Newsfeed.Enter article title")}
                        value={title}
                        onChange={handleTitleChange}
                        // required
                        invalid={display && title.trim() === ""}

                      />
                    </div>
                    {display && title.trim() === "" && (
                      <span className="error_msg_lbl">{t("Newsfeed.Enter article title")}</span>
                    )}
                  </div>

                  <div className="col-12 mb-3">
                    <label className="form-label fw-medium">{t("Newsfeed.Tags")}<span className="text-danger ms-1">*</span>
                    </label>
                    <Select
                      mode="tags"
                      className="ArticleHuzTagColor HuzTagselectInner"
                      style={{ width: "100%" }}
                      placeholder={t("Newsfeed.Enter Tags")}
                      onChange={handleTagChange}
                      value={selectedTags}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      dropdownStyle={{
                        zIndex: 9999,
                        position: "fixed",
                      }}
                    >
                      {tagOptions?.map((tag) => (
                        <Select.Option key={tag?.atmid} value={tag?.tagName}>
                          {/* {tag?.tagName} */}
                            {tag?.tagName.replace(/[\[\]"]/g, "").trim()}   
                        </Select.Option>
                      ))}
                    </Select>
                    {display && (!selectedTags || selectedTags.length === 0) && (
                      <span className="error_msg_lbl ArticleHuzTagColor">{t("Newsfeed.Enter Tags")}</span>
                    )}
                  </div>

                  {/* <div className="col-12 mb-4">
                    <label className="form-label fw-medium">Content *</label>
                    <ReactQuill
                      ref={editorRef}
                      value={description}
                      onChange={(content, delta, source, editor) => {
                        handleArticleChange(content, delta, source, editor);
                      }}
                      modules={modules}
                      formats={formats}
                      theme="snow"
                      className="form-quill"
                      placeholder="Write or paste your article content here..."
                    /> 
                    {showSuggestions && (
                      <ul className="suggestion-box">
                        {mentionType === "Hashtag" ? <li
                          onMouseDown={(e) => {
                            e.preventDefault(); // Prevent editor blur
                            insertMention(
                              SearchText,
                              null
                            );
                          }}
                          className="suggestion-item"
                        >
                          <span>{SearchText ? `#${SearchText}` : ''}</span>
                        </li> : null}
                        {suggestions?.map((item, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(
                                mentionType === "UserMention"
                                  ? item?.entityName
                                  : item?.hashTag,
                                mentionType === "UserMention"
                                  ? item?.userUid
                                  : null
                              );
                            }}
                            className="suggestion-item"
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img
                                  src={item?.avatar}
                                  alt={item?.entityName}
                                  className="avatar"
                                />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div> */}
                  <div className="col-12 mb-4">
                    <label className="form-label fw-medium">{t("Newsfeed.Content")}<span className="text-danger ms-1">*</span>
                    </label>

                    <div
                      ref={quillRef}
                      value={description}
                      className="form-quill content-textarea AddArticleNewQuill"
                      // style={{ minHeight: "250px", backgroundColor: "#fff" }}
                    ></div>

                    {showSuggestions && (
                      <ul className="suggestion-box">
                        {mentionType === "Hashtag" && (
                          <li
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(SearchText, null);
                            }}
                            className="suggestion-item"
                          >
                            <span>{SearchText ? `#${SearchText}` : ""}</span>
                          </li>
                        )}
                        {suggestions?.map((item, index) => (
                          <li
                            key={index}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              insertMention(
                                mentionType === "UserMention" ? item?.entityName : item?.hashTag,
                                mentionType === "UserMention" ? item?.userUid : null
                              );
                            }}
                            className="suggestion-item"
                          >
                            {mentionType === "UserMention" ? (
                              <>
                                <img src={item?.avatar} alt={item?.entityName} className="avatar" />
                                <span>{item?.entityName}</span>
                              </>
                            ) : (
                              <span>#{item?.hashTag}</span>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* {display && (!postInputValue || postInputValue.trim() === "") && (
                      <span className="error_msg_lbl">{t("Newsfeed.Please enter content")}</span>
                    )} */}
                  </div>


                  <div className="col-12 d-flex justify-content-center mt-5">
                    <button
                      className="mainBtn"
                      type="submit"
                      disabled={isloading}
                    // onClick={handleSubmit}
                    >
                      {isloading === true ? t("Newsfeed.Posting") : t("Newsfeed.Post Article")}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default AddArticle;
